import React from "react";
import { makeStyles } from "@material-ui/core";
import { Route, Switch } from "react-router-dom";
import PanRequestForm from "pages/module/pan/PanRequestForm";
import PanTransactionResponse from "pages/module/pan/PanTransactionResponse";
import PanPaymentDetails from "pages/module/pan/PanPaymentDetails";
import PanPaymentStatus from "pages/module/pan/PanPaymentStatus";
import PanStatusResponse from "pages/module/pan/PanStatusResponse";

const PanServiceLayout = (props) => {
    const classes = useStyles();

    return(
        <div className={classes.root}>
            <props.appconst.postLoginNavbar {...props} isSearchPage={true} showServices={true}/>
            <div className="page-main-content">
                <Switch>
                    <Route path="/pan/new-pan-request" component={PanRequestForm}/>
                    <Route path="/pan/application/response" component={PanTransactionResponse}/>
                    <Route path="/pan/payment-details" component={PanPaymentDetails}/>
                    <Route path="/pan/payment-status/:tid" component={PanPaymentStatus}/>
                    <Route path="/pan/status/response" comonent={PanStatusResponse}/>
                </Switch>
            </div>
            <props.appconst.pageFooter white {...props}/>
        </div>
    );
};

export default PanServiceLayout;

const useStyles = makeStyles(theme => ({
    root: {
        margin: 0,
        padding: 0,
        "& .page-main-content": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
        }
    }
}));
